import { readStorageItem, removeStorageItem, writeStorageItem } from '@/utils/storage';

export interface ReportDraftPayload {
  todayWork: string;
  tomorrowPlan?: string;
  problemRemark?: string;
  imageIds: string[];
  savedAt: string;
}

function draftKey(userId: string, dateKey: string): string {
  return `daily-report:report-draft:${userId}:${dateKey}`;
}

export function loadReportDraft(userId: string, dateKey: string): ReportDraftPayload | null {
  const raw = readStorageItem(draftKey(userId, dateKey));
  if (!raw) {
    return null;
  }
  try {
    return JSON.parse(raw) as ReportDraftPayload;
  } catch {
    return null;
  }
}

export function saveReportDraft(userId: string, dateKey: string, payload: ReportDraftPayload): void {
  writeStorageItem(draftKey(userId, dateKey), JSON.stringify(payload));
}

export function clearReportDraft(userId: string, dateKey: string): void {
  removeStorageItem(draftKey(userId, dateKey));
}
